module.exports = __webpack_public_path__ + "static/media/UPI.1223162b.svg";